import { MAX_ALLOWED_RECURRING_SUBSCRIPTIONS } from '@flexible-reports/limits/flexible-reports-limits';

const errorMessagesTranslateMap = {
  'reportName.required': {
    id: 'flexible_reports_report_name_required_validation_message',
    default: 'Enter a report name'
  },
  'reportName.invalidCharacters': {
    id: 'flexible_reports_report_name_invalid_characters_validation_message',
    default: `Remove special characters like <, >, { or }`
  },
  'reportName.duplicate': {
    id: 'flexible_reports_report_name_already_exists_form_validation_message',
    default: 'Report name already exists'
  },
  'reportFilters.advertisers.required': {
    id: 'flexible_reports_advertiser_accounts_required_validation_message',
    default: 'Add at least 1 advertiser account'
  },
  'reportFilters.accounts.required': {
    id: 'flexible_reports_accounts_required_validation_message',
    default: 'Add at least 1 account'
  },
  'reportFilters.advertisers.accessLost': {
    id: 'flexible_reports_advertiser_accounts_partial_access_lost_validation_message',
    default: `You've lost access to 1 or more advertiser accounts in your report subscription. Review and update your account selection.`
  },
  'reportFilters.advertisers.accessLostAll': {
    id: 'flexible_reports_all_advertiser_accounts_access_lost',
    default: `You've lost access to all advertiser accounts in your report subscription. Review and update your account selection.`
  },
  'reportFilters.managerAccounts.accessLost': {
    id: 'flexible_reports_manager_accounts_partial_access_lost_validation_message',
    default: `You've lost access to 1 or more manager accounts in your report subscription. Review and update your account selection.`
  },
  'reportFilters.managerAccounts.accessLostAll': {
    id: 'flexible_reports_all_manager_accounts_access_lost',
    default: "You've lost access to all manager accounts in your report subscription. Review and update your account selection."
  },
  'reportFilters.campaigns.required': {
    id: 'flexible_reports_campaigns_required_validation_message',
    default: 'Add at least 1 campaign'
  },
  'reportFilters.campaigns.accessLost': {
    id: 'flexible_reports_campaigns_partial_access_lost',
    default: "You've lost access to 1 or more campaigns in your report subscription. Review and update your campaign selection."
  },
  'reportFilters.campaigns.accessLostAll': {
    id: 'flexible_reports_all_campaigns_access_lost',
    default: "You've lost access to all campaigns in your report subscription. Review and update your campaign selection."
  },
  'reportFields.dimensions.time.required': {
    id: 'flexible_reports_time_dimension_required_validation_message',
    default: 'Select at least 1 time dimension'
  },
  'reportFields.dimensions.levelOfDetail.required': {
    id: 'flexible_reports_level_of_detail_dimension_required_validation_message',
    default: 'Select at least 1 level of detail dimension from advertiser account, campaign, ad group, or ad'
  },
  'reportFields.metrics.required': {
    id: 'flexible_reports_metric_required_validation_message',
    default: 'Select at least 1 metric'
  },
  'reportFields.columns.incompatible': {
    id: 'flexible_reports_report_failure_code_invalid_metric_combination_validation_message',
    default: 'Select a valid dimension and metric combination'
  },
  'reportFields.columns.overLimit': {
    id: 'flexible_reports_report_failure_code_too_many_selections',
    default: 'We encountered an unexpected error. Please try again or contact our support team if the issue continues.'
  },
  'reportPeriod.invalid': {
    id: 'flexible_reports_report_failure_code_invalid_date_range_validation_message',
    default: 'Select a valid date range'
  },
  'reportSchedule.daysOfWeek.required': {
    id: 'flexible_reports_weekly_recurring_day_required_validation_message',
    default: 'Select at least 1 day of the week'
  },
  'reportSchedule.frequency.recurringOverLimit': {
    id: 'flexible_reports_report_failure_code_too_many_recurring_reports_validation_message',
    default: 'Your report request exceeds the maximum number of {{count}} recurring reports. Update your selection.',
    options: {
      count: MAX_ALLOWED_RECURRING_SUBSCRIPTIONS
    }
  }
};

export { errorMessagesTranslateMap };
export type ErrorMessageKey = keyof typeof errorMessagesTranslateMap;
